import {cloneDeep} from 'lodash';
import * as React from 'react';

import {IPosterImage, IDocument, IUserData} from '../../../../infrastructure/interfaces';
import PosterImageBackgroundForm from '../../../DocumentEditor/PosterImageBackgroundEditorForm';
import SettingsNav from './SettingsNav';

export interface IPosterImageBackgroundProps {
  document: IDocument;
  posterImagesList: IPosterImage[];
  userData: IUserData;
  saveDocument(document: IDocument, userID: string, redirect?: string): void;
  updateModelDocument(document: IDocument): void;
  cancelDocument(): void;
}

export interface IPosterImageBackgroundState {
  document: IDocument;
}


export default class PosterImageBackground extends React.Component<IPosterImageBackgroundProps, IPosterImageBackgroundState> {
  contentNode: Element;
  constructor(props: IPosterImageBackgroundProps) {
    super(props);
    this.state = {
      document: cloneDeep(props.document),
    };
  }

  componentWillUnmount() {
    if (this.props.updateModelDocument) {
      this.contentNode.parentElement!.scrollTop = 0;
      this.props.updateModelDocument(this.state.document);
    }
  }

  componentWillReceiveProps(nextProps: IPosterImageBackgroundProps) {
    if (nextProps.document !== this.props.document) {
      this.setState({ document: cloneDeep(nextProps.document) });
    }
  }

  onPosterImageBackgroundChange = (posterImageBackground: IPosterImage) => {
    this.setState({
      document: {
        ...this.state.document,
        posterImageBackground,
      },
    });
  }

  cancel = () => {
    this.setState({ document: cloneDeep(this.props.document) });
    if (this.props.cancelDocument) {
      this.props.cancelDocument();
    }
  }

  onSave = () => {
    this.props.saveDocument(this.state.document, this.props.userData.id);
  }

  render() {
    return (
      <div className="cropsEditorContainer" ref={(node) => { this.contentNode = node!; }}>
        <SettingsNav
          cancel={this.cancel}
          document={this.state.document}
          onSave={this.onSave}
        />
        <div className="">
          <div className="cropsContainerTitle">
            Select the poster background image:
        </div>
        </div>
        <PosterImageBackgroundForm
          document={this.state.document}
          posterImagesList={this.props.posterImagesList}
          onPosterImageChangeBackground={this.onPosterImageBackgroundChange}
          className="settingsCropsListContainer"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/Settings/PosterImageBackgroundEditor.tsx